import type { ReactElement } from 'react'
import { toNumber } from 'lodash-es'
import { Vector3 } from 'three'
import { useResultsStore } from '@editorStores'
import {
  formatMemberCheckPosition,
  toggleSelectedCheckHighlight,
} from '../../../Results2DetailPane/utils'
import SceneLabelChip from '../SceneLabelChip'

export type CheckPositionSceneLabelItem = {
  id: string
  relativePosition: string
  checkType: MemberCheckType
  p: Vector3
}

type Props = {
  items: CheckPositionSceneLabelItem[]
  elementGuidForChecks: string | null
  showFloorplan: boolean
}

/** Marks the position of the selected non-support member check in the scene. */
const CheckPositionSceneLabels = ({
  items,
  elementGuidForChecks,
  showFloorplan,
}: Props): ReactElement | null => {
  const highlightedCheck = useResultsStore(state => state.highlightedCheck)
  const setHighlightedCheck = useResultsStore(state => state.setHighlightedCheck)

  if (!elementGuidForChecks || items.length === 0) return null

  return (
    <group position={[0, showFloorplan ? -0.15 : 0, 0]}>
      {items.map(item => (
        <SceneLabelChip
          key={item.id}
          position={item.p}
          highlighted
          showFloorplan={showFloorplan}
          onClick={() =>
            toggleSelectedCheckHighlight(
              elementGuidForChecks,
              item.relativePosition,
              item.checkType,
              highlightedCheck,
              setHighlightedCheck,
            )
          }
        >
          {formatMemberCheckPosition(toNumber(item.relativePosition))}
        </SceneLabelChip>
      ))}
    </group>
  )
}

export default CheckPositionSceneLabels
